import $ from 'jquery';

export class rangeSlider {
    ranges = [
        "5 km",
        "10 km",
        "15 km",
        "20 km",
        "25 km",
        "30 km",
        "40 km",
        "50 km",
        "75 km",
        "100 km",
        "200 km",
        "Alle afstanden"
    ];
    rangeValues = [
        5, 10, 15, 20, 25, 30, 40, 50, 75, 100, 200, 50000
    ];
    container;
    element;

    constructor(element) {
        this.element = $(element);
        this.container = this.element.closest('.distance-container');

        // listen
        this.element.on('input', _ => this.changed());

        if(this.container.data('value') !== undefined) {
            this.setValue(this.findClosestIndex(this.container.data('value')));
        }
    }

    changed() {
        this.setValue(this.element.val());
    }

    setValue(val) {
        this.element.val(val);
        let newVal = this.ranges[val];
        let newValNum = this.rangeValues[val]
        let newLeft = "auto";
        let newRight = "auto";
        let proportion = (val / (this.ranges.length - 1) * 100);
        if (proportion >= 50) {
            newRight = String(100 - proportion + "%");
        } else {
            newLeft = String(proportion + "%");
        }
        this.container.find('.distance-output-value').text(newVal)
        this.container.find('.distance-output').css("left", newLeft).css("right", newRight);
        this.container.find('.distance-form-input').attr("value", newValNum);
        this.container.find('.distance-form-input').trigger('change');
    }

    findClosestIndex(value) {
        const val = this.rangeValues.filter(item => item <= value).splice(-1, 1)[0] ?? this.rangeValues[0];
        return this.rangeValues.indexOf(val);
    }
}
